export default {
  firebaseConfig: {
    apiKey: "AIzaSyDp_KQoI11tUcsWzEfvV1qo3snfGUJvslA",
    authDomain: "pro.acry.co.jp",
    databaseURL: "https://ship-13c30-default-rtdb.firebaseio.com",
    projectId: "ship-13c30",
    storageBucket: "stiq-app-bucket",
    messagingSenderId: "716020021358",
    appId: "1:716020021358:web:1c29abc616b37942f1ce7f",
    // measurementId: "G-S5XDVKKHSJ"
  },
  domain: "https://nship.net",
  testSuffix: "",
  isAgent: false,
  isDebug: false,
  isNP:false,
  rootFolder: "acrypro",
  ncmb: {
    applicationKey:"659b5612a0bf4439c4a1ac00066bd5eeb1a794267651326b69efe7e621e91312",
    clientKey:"3be4f8e99dfd7276510841eef4d94353edb4dd13b3e302d36931949e18f74679",
  },
  s3DesignFilePath:"https://acry.s3.ap-northeast-1.amazonaws.com/release/UserSharedFile/",
  ticketWebUrl:"https://ticket.acry.co.jp",
}
